var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeshboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.875 16.25C4.875 15.3526 5.60255 14.625 6.5 14.625H11.375C12.2724 14.625 13 15.3526 13 16.25V21.125C13 22.0224 12.2724 22.75 11.375 22.75H6.5C5.60255 22.75 4.875 22.0224 4.875 21.125V16.25Z",
    fill: "url(#paint0_linear_4003_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 6.5C14.625 5.60255 15.3526 4.875 16.25 4.875H21.125C22.0224 4.875 22.75 5.60255 22.75 6.5V11.375C22.75 12.2724 22.0224 13 21.125 13H16.25C15.3526 13 14.625 12.2724 14.625 11.375V6.5Z",
    fill: "url(#paint1_linear_4003_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 16.25C14.625 15.3526 15.3526 14.625 16.25 14.625H21.125C22.0224 14.625 22.75 15.3526 22.75 16.25V21.125C22.75 22.0224 22.0224 22.75 21.125 22.75H16.25C15.3526 22.75 14.625 22.0224 14.625 21.125V16.25Z",
    fill: "url(#paint2_linear_4003_128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 5.6875C3.25 4.34131 4.34131 3.25 5.6875 3.25H13C14.3462 3.25 15.4375 4.34131 15.4375 5.6875V13C15.4375 14.3462 14.3462 15.4375 13 15.4375H5.6875C4.34131 15.4375 3.25 14.3462 3.25 13V5.6875Z",
    fill: "url(#paint3_linear_4003_128)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_128",
    x1: 8.9375,
    y1: 14.625,
    x2: 8.9375,
    y2: 22.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4003_128",
    x1: 18.6875,
    y1: 4.875,
    x2: 18.6875,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4003_128",
    x1: 18.6875,
    y1: 14.625,
    x2: 18.6875,
    y2: 22.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4003_128",
    x1: 8.62672,
    y1: 3.25,
    x2: 8.62672,
    y2: 15.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeshboard);
export default __webpack_public_path__ + "static/media/deshboard.5edad2f6c67377cacd400ffdec402bc4.svg";
export { ForwardRef as ReactComponent };